module.exports = __webpack_public_path__ + "img/28.8de176d3.png";